import type { AlgoliaIndices } from '@nuxtjs/algolia';

export const useAlgolia = () => {
    const { locale } = useLocales();
    const algoliaSearchClient = useAlgoliaRef();

    const algoliaIndex = useAlgoliaInitIndex(`PROD_${locale.value.toUpperCase()}` as keyof AlgoliaIndices);

    return {
        algoliaSearchClient,
        algoliaIndex,
    };
};
